import React, {Component} from 'react'
import _ from 'lodash';
import { PAGE_BUTTON_ID } from '../actions/constants'
import Pagination from "react-js-pagination";

class EndpointPagination extends Component {
    constructor(props){
        super(props)
        this.state = {
            value: Number(this.props.currentListPage) + 1,
            listPages: this.props.listPages,
            value1 : Number(this.props.currentListPage) + 1,
            es: null,
            isDisable: true,
            activePage: Number(this.props.currentListPage) + 1
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleClick = this.handleClick.bind(this)
        // this.handleDebounce = this.handleDebounce.bind(this)

    }
    // componentDidUpdate = (prevProps, prevState) => {
    //     if (prevState.value1 == this.state.value1 ) {
    //       console.log('pokemons state has changed.')
    //       this.setState({
    //         isDisable: false
    //       })
    //     }
    //   }
    handleChange(e){
        // console.log('THIS',this.props)
        // this.handleClick(e);
        // let val = e.target.value
        // let lp = this.props.listPages
        // let setVal = null;
        // if( val >= 0 && val <= lp ){
        //     setVal = val
        // } else if( val > lp ){
        //     setVal = lp
        // } else if( val === 0 ){
        //     setVal = 1
        // }
        //console.log('THO',e.target.value)
        this.setState({  
            value1: e.target.value,
            es: e.currentTarget.id,
            isDisable: false
         })
        
    }

    static getDerivedStateFromProps(props, state){
        // If redux store currentListPage changes, also change the local state
        if(props.listPages !== state.listPages || props.currentListPage !== state.value){
            return {
                value: props.currentListPage +1,
                listPages: props.listPages
            }
        }
        return null
    }

    handleClick(e){
        let propsval = Number(this.props.currentListPage) + 1
        let nameArr = e.currentTarget.id.split(PAGE_BUTTON_ID)
        this.setState({
            value: nameArr[1] === 'prev' ? 
                propsval - 1:
                propsval + 1,
            listPages: this.props.listPages
        })
    }
    handlePageChange = (pageNumber)=> {
        this.setState({activePage: pageNumber});
      }

    render(){

        let { 
            itemsPerPage,
            handleClick, 
            currentListPage, 
            listPages, 
            id,
            handleClickPagination
        } = this.props
        let disabledPrev = currentListPage === 0
        let disabledNext = currentListPage >= ( listPages - 1 )

        let activePage = currentListPage == 0 ? currentListPage + 1 : currentListPage + 1
        return (
            
            <Pagination
                // style={{marginBottom: "0px !important", border: "1px solid red !important"}}
                activePage={activePage}
                itemsCountPerPage={itemsPerPage}
                totalItemsCount={this.props.listCount}
                pageRangeDisplayed={10}
                onChange={ e=> 
                    {
                        let es = e - 1
                        // console.log('E',e)
                        this.handlePageChange(e)
                        handleClickPagination(es,id)
                    }
                }
                itemClass="page-item"
                linkClass="page-link"
            />
        )
    }
}

export default EndpointPagination




// WEBPACK FOOTER //
// ./src/components/endpointPagination.js